import { isNumber } from "@bonusmap/shared_ui/library";
import { BapGroups } from "./bap-groups";
import { InputParamGroup } from "./bap-types";
import { BlockAnalyzed } from "./block-analyzed";
/**
 * Blocco per mostrare un gruppo di parametri
 */
export class BapGroup extends BlockAnalyzed  {
    static override webComponentName: string = "bap-group";
    protected override _templateId: string = "bap-group";
    private _bapGroups!: BapGroups;
    get bapGroups(): BapGroups {
        if(!this._bapGroups) {
            this._bapGroups = this.closest('bap-groups') as BapGroups;
        }
        return this._bapGroups;
    }
    private _index: number = -1;
    public get index(): number {
        if (this._index === -1) {
            const attr = this.getAttribute('index');
            if (attr) {
                const idx = parseInt(attr);
                if (!isNaN(idx) && idx >= 0) {
                    this._index = idx;
                }
            }
        }
        return this._index;
    }
    private _value!: InputParamGroup;
    public get value(): InputParamGroup {
        if(!this._value && isNumber(this.index) && this.bapGroups.value) {
            this._value = this.bapGroups.value[this.index];
        }
        return this._value;
    }
    public set value(value: InputParamGroup) {
        this._value = value;
    }
    constructor() {
        super();
    }

    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        
        return {
            ...baseData,
            value: this.value || null
        };
    }
} 